import { Injectable }               from '@angular/core';
import { Http,
         Response,
         Headers,
         RequestOptions,
         URLSearchParams }          from '@angular/http';
import { ISortableFilter }          from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { objectToParams }           from './../common/functions';
import { GridInterfaceService }     from './grid.interface.service';
import { CommonService }            from './common.service';
import { MatSnackBar }              from '@angular/material';

@Injectable()
export class CurrencyService implements GridInterfaceService {

    private _commonService: CommonService;

    constructor(public authHttp: AuthHttp, private http: Http, private globals: Globals, public snackbar: MatSnackBar) {
        this._commonService = new CommonService(authHttp, http, globals, 'currency', snackbar);
    }

    public getItems(): Observable<any> {
        return this._commonService.getItems(null);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/currency.service.ts